function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import App from 'modules/App';
import * as constants from '../../../constants';
import * as shapes from '../../../shapes';
import messages from '../../../messages';
import AddCountryForm from './AddCountryForm';
var _React_PureComponent;
class AddCountryModal extends (_React_PureComponent = React.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.isInProgress && !this.props.isInProgress && !this.props.hasErrors) {
            this.props.onClose();
        }
    }
    renderContent() {
        return /*#__PURE__*/ _jsx(AddCountryForm, {
            languageOptions: this.props.languageOptions,
            isInProgress: this.props.isInProgress,
            hasErrors: this.props.hasErrors,
            onClose: this.props.onClose
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(Modal, {
            modalId: constants.ADD_COUNTRY_MODAL,
            openModalId: this.props.openModalId,
            headerMessage: messages.headers.addNewCountry,
            styleModifier: "lg",
            isInProgress: this.props.isInProgress,
            onClose: this.props.onClose,
            children: this.renderContent()
        });
    }
}
_define_property(AddCountryModal, "propTypes", {
    // Explicit props
    languageOptions: PropTypes.arrayOf(shapes.language),
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit props
    openModalId: PropTypes.string,
    // Implicit actions
    onClose: PropTypes.func
});
const mapStateToProps = (state)=>({
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onClose: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedAddCountryModal = connect(mapStateToProps, mapDispatchToProps)(AddCountryModal);
export default ConnectedAddCountryModal;
